import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { View, Text, ImageBackground, ScrollView } from 'react-native';
import {
  WorkoutContainerHeaderTwo,
  WorkoutContainerHeaderThree,
  WorkoutContainerText,
  WorkoutTextSubHeader,
  WorkoutTextHeader,
  WorkoutCommonButton
} from  '../styles/common-styles';
import styled from 'styled-components/native';

function ActivityStartScreen({startScreenProps, startButtonCallback}) {
  return (
      <ActivityStartScreenParent>
        <ActivityStartScreenOne
            source={{ uri: 'https://dev.cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/backgrounds/Cerebrocore_workout-bkg-weight.png' }}
            resizeMode='contain'
        >
          <ActivityStartOneTextContainer>
            <WorkoutTextSubHeader style={{fontSize: 18, marginBottom:5}}>WARM UP</WorkoutTextSubHeader>
            <WorkoutTextHeader style={{color:'white', fontSize:28}}>{startScreenProps.activityName}</WorkoutTextHeader>
            <WorkoutCommonButton style={{marginTop:35}} onPress={() =>{
              startButtonCallback();
            }}>
              <Text style={{ color: 'white', fontWeight: '500' }}>BEGIN</Text>
            </WorkoutCommonButton>
          </ActivityStartOneTextContainer>
        </ActivityStartScreenOne>


        <ActivityStartScreenTwo>

          <ActivityStartTwoTextContainer>
            <WorkoutTextSubHeader style={{marginBottom:10, fontSize:18}}>{startScreenProps.activityIntroHeader}</WorkoutTextSubHeader>
            <WorkoutContainerText style={{fontSize: 20}}>{startScreenProps.activityIntroBody}</WorkoutContainerText>
          </ActivityStartTwoTextContainer>

        </ActivityStartScreenTwo>
      </ActivityStartScreenParent>
  );
}

export const ActivityStartScreenParent = styled.ScrollView`
    width:100%;
    height:100%;
  `;

export const ActivityStartScreenOne = styled.ImageBackground`
    width:100%;
    height:300px;
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:left;
    background-color:#282F63;
  `;

export const ActivityStartOneTextContainer = styled.View`
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
  `

export const ActivityStartScreenTwo = styled.View`
    width:100%;
    height:auto;
    display:flex;
    justify-content:center;
    align-items:center;
    text-align:left; 
    padding-bottom:50px;
  `;

export const ActivityStartTwoTextContainer = styled.View`
    width:80%;
    height:85%;
`

export default ActivityStartScreen;